import React from 'react';
import CircularProgress from "@material-ui/core/CircularProgress";
import withStyles from '@material-ui/core/styles/withStyles';

class Loading extends React.Component{
    render(){
        const { classes } = this.props;

        return(
            <div className={classes.loading}>
                <div>
                    <CircularProgress size={60}/>
                </div>
            </div>
        )
    }
}

const styles = {
    loading: {
        textAlign: 'center',
        '&>div': {
            display: 'inline-block'
        }
    }
};

export default withStyles(styles)(Loading);